// frontend/src/App.jsx
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
// import Home from "./pages/home/Home";
import Login from "./pages/home/Login";
import Events from "./pages/home/Events";
import Gallery from "./pages/home/Gallery";
import AboutUs from "./pages/home/AboutUs";
import Players from "./pages/home/Players";
import News from "./pages/home/News";
import UpdatesResults from "./pages/home/UpdatesResults";
import Donate from "./pages/home/Donate";
import Messages from "./pages/home/Messages";
import Volunteer from "./pages/home/Volunteer";
import Partner from "./pages/home/Partner";
import ChaitanyaYatra from "./pages/home/ChaitanyaYatra";
import PrivacyPolicy from "./pages/home/PrivacyPolicy";
import Terms from "./pages/home/Terms";
import HomeRedirect from "./HomeRedirect";
import PlayerRegister from "./pages/home/PlayerRegister";
import Verify from "./pages/verify";
import LiveScoreboard from "./pages/public/LiveScoreboard";

// Admin Pages
import ChangePassword from "./pages/ChangePassword";
import AdminDashboard from "./pages/admin/AdminDashboard";
import ManagePlayers from "./pages/admin/ManagePlayers";
import ManageEvents from "./pages/admin/ManageEvents";
import ManageGallery from "./pages/admin/ManageGallery";
import ManageSlider from "./pages/admin/ManageSlider";
import ReportsDashboard from "./pages/admin/Reports";
import AdminProfile from "./pages/admin/AdminProfile";
import EventRegistrations from "./pages/admin/EventRegistrations";
import VolunteerRegistrations from "./pages/admin/VolunteerRegistrations";
import PlayerClassification from "./pages/admin/PlayerClassification";
import GameDay from "./pages/admin/GameDay";
import GameDay2 from "./pages/admin/GameDay2";
// import SportConfig from "./pages/admin/SportConfig";
import ResultsManager from "./pages/admin/ResultsManager";
import TimedResults from "./pages/admin/results/TimedResults";
import PointsResults from "./pages/admin/results/PointsResults";
import BracketManager from "./pages/admin/results/BracketManager";
import TeamManager from "./pages/admin/results/TeamManager";
import PlayerAchievements from "./pages/admin/PlayerAchievements";
import CertificatesManager from "./pages/admin/CertificatesManager";
import IssuedCertificates from "./pages/admin/IssuedCertificates";
import GameEngine from "./pages/admin/GameEngine";
import MedalTally from "./pages/admin/MedalTally";
import ScheduleBoard from "./pages/admin/ScheduleBoard";
import EligibilityManager from "./pages/admin/EligibilityManager";
import DistrictRegistration from "./pages/admin/DistrictRegistration";
import ManageContentSections from "./pages/admin/ManageContentSections";
import MailCenter from "./pages/admin/MailCenter";
import ScoreSheetRules from "./pages/admin/ScoreSheetRules";
import OccasionPostersManager from "./pages/admin/OccasionPostersManager";

// Secretary Dashboards
import SecretaryDashboard from "./pages/secretary/SecretaryDashboard";
import DistrictDashboard from "./pages/district/DistrictDashboard";

// Player Dashboards
import PlayerLayout from "./pages/player/PlayerLayout";
import PlayerDashboard from "./pages/player/PlayerDashboard";
import PlayerProfile from "./pages/player/PlayerProfile";
import CertificatesDownload from "./pages/player/Certificates";
import EventRegistration from "./pages/player/EventRegistration";
import MyRegistrations from "./pages/player/MyRegistrations";
import AdminClassicShell from "./components/admin/AdminClassicShell";

// Route Guards
import { PublicRoute } from "./routes/RouteGuards";
import ProtectedRoute from "./components/ProtectedRoute";

function App() {
  const withAdminClassic = (page) => (
    <AdminClassicShell>{page}</AdminClassicShell>
  );

  return (
    <Routes>
      {/* Public Pages */}
      <Route path="/" element={<HomeRedirect />} />
      <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
      <Route path="/register" element={<PublicRoute><PlayerRegister /></PublicRoute>} />
      <Route path="/events" element={<PublicRoute><Events /></PublicRoute>} />
      <Route path="/gallery" element={<PublicRoute><Gallery /></PublicRoute>} />
      <Route path="/players" element={<PublicRoute><Players /></PublicRoute>} />
      <Route path="/about-us" element={<PublicRoute><AboutUs /></PublicRoute>} />
      <Route path="/news" element={<PublicRoute><News /></PublicRoute>} />
      <Route path="/updates-results" element={<PublicRoute><UpdatesResults /></PublicRoute>} />
      <Route path="/donate" element={<PublicRoute><Donate /></PublicRoute>} />
      <Route path="/messages" element={<PublicRoute><Messages /></PublicRoute>} />
      <Route path="/volunteer" element={<PublicRoute><Volunteer /></PublicRoute>} />
      <Route path="/partner" element={<PublicRoute><Partner /></PublicRoute>} />
      <Route path="/chaitanya-yatra" element={<PublicRoute><ChaitanyaYatra /></PublicRoute>} />
      <Route path="/privacy-policy" element={<PublicRoute><PrivacyPolicy /></PublicRoute>} />
      <Route path="/terms" element={<PublicRoute><Terms /></PublicRoute>} />
      <Route path="/live-score/:event_id" element={<LiveScoreboard />}/>
      <Route path="/verify/player/:id" element={<Verify />} />
      <Route path="/verify/escort/:id/:eventId" element={<Verify />} />

      {/* Player Dashboard Routes */}
      <Route element={<ProtectedRoute allowedRoles={["player"]}><PlayerLayout /></ProtectedRoute>}>
        <Route path="/player" element={<PlayerDashboard />} />
        <Route path="/player-profile" element={<PlayerProfile />} />
        <Route path="/certificates" element={<CertificatesDownload />} />
        <Route path="/register-event" element={<EventRegistration />} />
        <Route path="/player/my-registrations" element={<MyRegistrations />} />
      </Route>

      {/* Admin Routes */}
      <Route path="/admin" element={<ProtectedRoute allowedRoles={["admin","secretary","district"]}><AdminDashboard /></ProtectedRoute>} />
      <Route path="/admin/manage-players" element={<ProtectedRoute allowedRoles={["admin","secretary","district"]}>{withAdminClassic(<ManagePlayers />)}</ProtectedRoute>} />
      <Route path="/admin/gallery" element={<ProtectedRoute allowedRoles={["admin","secretary"]}>{withAdminClassic(<ManageGallery />)}</ProtectedRoute>} />
      <Route path="/admin/slider" element={<ProtectedRoute allowedRoles={["admin","secretary"]}>{withAdminClassic(<ManageSlider />)}</ProtectedRoute>} />
      <Route path="/admin/reports" element={<ProtectedRoute allowedRoles={["admin","secretary"]}>{withAdminClassic(<ReportsDashboard />)}</ProtectedRoute>} />
      <Route path="/admin/profile" element={<ProtectedRoute allowedRoles={["admin","secretary","district"]}>{withAdminClassic(<AdminProfile />)}</ProtectedRoute>} />
      <Route path="/admin/manage-events" element={<ProtectedRoute allowedRoles={["admin","secretary","district"]}>{withAdminClassic(<ManageEvents />)}</ProtectedRoute>} />
      <Route path="/admin/district-registration" element={<ProtectedRoute allowedRoles={["admin","secretary"]}>{withAdminClassic(<DistrictRegistration />)}</ProtectedRoute>} />
      <Route path="/admin/content-sections" element={<ProtectedRoute allowedRoles={["admin","secretary"]}>{withAdminClassic(<ManageContentSections />)}</ProtectedRoute>} />
      <Route path="/admin/mail-center" element={<ProtectedRoute allowedRoles={["admin","secretary"]}>{withAdminClassic(<MailCenter />)}</ProtectedRoute>} />
      <Route path="/admin/occasion-posters" element={<ProtectedRoute allowedRoles={["admin","secretary"]}>{withAdminClassic(<OccasionPostersManager />)}</ProtectedRoute>} />
      <Route path="/admin/score-sheet-rules" element={<ProtectedRoute allowedRoles={["admin","secretary"]}>{withAdminClassic(<ScoreSheetRules />)}</ProtectedRoute>} />
      <Route path="/admin/event-registrations" element={<ProtectedRoute allowedRoles={["admin","secretary","district"]}>{withAdminClassic(<EventRegistrations />)}</ProtectedRoute>} />
      <Route path="/admin/volunteer-registrations" element={<ProtectedRoute allowedRoles={["admin","secretary","district"]}>{withAdminClassic(<VolunteerRegistrations />)}</ProtectedRoute>} />
      <Route path="/admin/classification-allotment" element={<ProtectedRoute allowedRoles={["admin","secretary","district"]}>{withAdminClassic(<PlayerClassification />)}</ProtectedRoute>} />
      <Route path="/admin/game-day" element={<ProtectedRoute allowedRoles={["admin","secretary","district"]}>{withAdminClassic(<GameDay />)}</ProtectedRoute>} />
      <Route path="/admin/game-day-2" element={<ProtectedRoute allowedRoles={["admin","secretary","district"]}>{withAdminClassic(<GameDay2 />)}</ProtectedRoute>} />
      <Route path="/admin/results" element={<ProtectedRoute allowedRoles={["admin","secretary","district"]}>{withAdminClassic(<ResultsManager />)}</ProtectedRoute>} />
      <Route path="/admin/results/timed/:event_id" element={<ProtectedRoute allowedRoles={["admin","secretary","district"]}>{withAdminClassic(<TimedResults />)}</ProtectedRoute>} />
      <Route path="/admin/results/points/:event_id" element={<ProtectedRoute allowedRoles={["admin","secretary","district"]}>{withAdminClassic(<PointsResults />)}</ProtectedRoute>} />
      <Route path="/admin/results/bracket/:event_id" element={<ProtectedRoute allowedRoles={["admin","secretary","district"]}>{withAdminClassic(<BracketManager />)}</ProtectedRoute>} />
      <Route path="/admin/results/team/:event_id" element={<ProtectedRoute allowedRoles={["admin","secretary","district"]}>{withAdminClassic(<TeamManager />)}</ProtectedRoute>} />
      <Route path="/admin/player-achievements" element={<ProtectedRoute allowedRoles={["admin","secretary","district"]}>{withAdminClassic(<PlayerAchievements />)}</ProtectedRoute> } />
      <Route path="/admin/certificates" element={<ProtectedRoute allowedRoles={["admin","secretary","district"]}>{withAdminClassic(<CertificatesManager />)}</ProtectedRoute>} />
      <Route path="/admin/certificates/issued" element={<ProtectedRoute allowedRoles={["admin","secretary","district"]}>{withAdminClassic(<IssuedCertificates />)}</ProtectedRoute>} />
      <Route path="/admin/game-engine" element={ <ProtectedRoute allowedRoles={["admin","secretary","district"]}>{withAdminClassic(<GameEngine />)}</ProtectedRoute>}/>
      <Route path="/admin/eligibility" element={<ProtectedRoute allowedRoles={["admin","secretary"]}>{withAdminClassic(<EligibilityManager />)}</ProtectedRoute>} />
      <Route path="/admin/medal-tally/:event_id" element={<ProtectedRoute allowedRoles={["admin","secretary","district"]}>{withAdminClassic(<MedalTally />)}</ProtectedRoute>}/>
      <Route path="/admin/schedule/:event_id" element={<ProtectedRoute allowedRoles={["admin","secretary","district"]}>{withAdminClassic(<ScheduleBoard />)}</ProtectedRoute>}/>
      <Route path="/admin/events" element={<Navigate to="/admin/manage-events" replace />} />
      <Route path="/admin/players" element={<Navigate to="/admin/manage-players" replace />} />
      <Route path="/admin/registrations" element={<Navigate to="/admin/event-registrations" replace />} />

      {/* Secretary & District Routes */}
      <Route path="/secretary" element={<ProtectedRoute allowedRoles={["secretary"]}><SecretaryDashboard /></ProtectedRoute>} />
      <Route path="/district" element={<ProtectedRoute allowedRoles={["district"]}><DistrictDashboard /></ProtectedRoute>} />

      {/* Shared Route */}
      <Route path="/change-password" element={<ProtectedRoute allowedRoles={["admin", "secretary", "district", "player"]}><ChangePassword /></ProtectedRoute>} />

      {/* Fallback Route */}
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}

export default App;
